import { EventTracker } from '@/hooks/gtm/useGTMEventTracker';

export const HomeBannerType = {
  EVENT: 'event',
  MAIN: 'main',
  FIXED: 'fixed',
  LINE: 'line',
  POPUP: 'popup',
};

export const EventPageAreaName = {
  GNB: 'GNB',
  // 실제 GA 수집은 HOME_MO, HOME 의 값이 같지만, 코드 상 구분을 위해 분리함
  HOME_MO: 'Home',
  HOME: 'Home',
  HOME_SNB: 'Home SNB',
  WORK_APPROVAL: 'Approval',
  WORK_DOCUMENT: 'Document',
  WORK_SNB: 'Work SNB',
  MYPAGE: 'mypage',
  SOCIAL: 'Social',
  BOARD_DETAIL: 'post detail',
  DAILY_SALES: 'DAILY SALES',
  SALES_ANALYSIS: 'SALES ANALYSIS',
  DAILY_RIVAL_RANK: 'DAILY RIVAL RANK',
} as const;
export type EventPageAreaType =
  (typeof EventPageAreaName)[keyof typeof EventPageAreaName];
export type SNBEventPageArea = (typeof EventPageAreaName)[
  | 'HOME_SNB'
  | 'WORK_SNB'];
export type HomePageAreaType =
  | typeof EventPageAreaName.HOME_MO
  | typeof EventPageAreaName.HOME
  | typeof EventPageAreaName.HOME_SNB;
export type WorkPageAreaType =
  | typeof EventPageAreaName.WORK_APPROVAL
  | typeof EventPageAreaName.WORK_DOCUMENT
  | typeof EventPageAreaName.WORK_SNB;
export type SalesPageAreaType =
  | typeof EventPageAreaName.DAILY_SALES
  | typeof EventPageAreaName.SALES_ANALYSIS
  | typeof EventPageAreaName.DAILY_RIVAL_RANK;

export const GTMEventName = {
  searchKeyword: 'search_keyword',
  clickMore: 'click_more',
  clickNotification: 'click_notifications',
  clickOutLink: 'click_outlink',
  viewPost: 'view_post',
  clickPostAction: 'click_post_action',
  viewProfile: 'view_profile_card',
} as const;

export const GNBEventName = {
  ...GTMEventName,
  clickTab: 'click_gnb',
  clickHome: 'click_home',
  clickProfile: 'click_profile',
  clickMenu: 'click_appbox',
} as const;
export type GNBEvent = (typeof GNBEventName)[keyof typeof GNBEventName];

/* Home */
export const HomeEventName = {
  ...GTMEventName,
  clickBanner: 'click_banner',
  clickEvent: 'click_event_home',
  toggleSNB: 'toggle_sidebar',
};
export type HomeEvent = (typeof HomeEventName)[keyof typeof HomeEventName];

/* Work */
export const WorkEventName = {
  ...GTMEventName,
  clickEvent: 'click_event_work',
  viewWork: 'view_approval',
  toggleSNB: 'toggle_sidebar',
};
export type WorkEvent = (typeof WorkEventName)[keyof typeof WorkEventName];

/* Mypage */
export const MypageEventName = {
  ...GTMEventName,
  clickEvent: 'click_event_mypage',
};
export type MypageEvent =
  (typeof MypageEventName)[keyof typeof MypageEventName];

/* Social */
export const SocialEventName = {
  ...GTMEventName,
  clickEvent: 'click_event_social',
};
export type SocialEvent =
  (typeof SocialEventName)[keyof typeof SocialEventName];

/* Sales */
export const SalesEventName = {
  ...GTMEventName,
  clickEvent: 'click_event_sales',
};
export type SalesEvent = (typeof SalesEventName)[keyof typeof SalesEventName];

////////////
export type GtmInfoProps<T extends string> = {
  gtmInfo?: {
    [key: string]: string | EventTracker<T>;
    eventTracker: EventTracker<T>;
    areaName: string;
  };
};
